// Скрипты для страницы новостей, сайта кубка fonbet
$(document).on('ready', function () {

    var fetchNewsAfterScrollPlugin = function ($wrapper) {
        var URL = '/cup/news/load-more';
        var findUrl = '/cup/news';
        var LOADING_CLASS = 'loading';
        var OFFSET_FOR_FETCH_NEWS = 200;
        var $list = $wrapper.find('.js-news-wrapper-find-list');
        var $select = $wrapper.find('.js-tournament-select');
        var findInput = $wrapper.find('.js-news-wrapper-find');
        var findButton = $wrapper.find('.js-news-wrapper-find-button');
        var $emptyList = $wrapper.find('.js-news-wrapper-find-list-empty');
        var $emptyListText = $emptyList.find('.js-news-wrapper-find-list-empty-text');

        var findData = {
            q: '',
        };

        var getPageFromUrl = function () {
            var urlParams = new URLSearchParams(window.location.search);
            var page = urlParams.get('page');

            if (page === null || isNaN(page)) {
                return 0;
            }

            return Number(page) - 1;
        };

        /**
         * заполняем данные из инпута в обьект
         */
        findInput.on('change', function () {
            findData.q = $(this).val();
        });

        var isLoading = false;
        var currentPage = getPageFromUrl();
        var isListEnd = false;

        var getBottomWrapperPositionInPage = function () {
            return $wrapper.offset().top + $wrapper.height();
        };

        var getWindowBottomPositionInPage = function () {
            return $(window).scrollTop() + $(window).height();
        };

        var isNeedLoadNews = function () {
          var difference = getBottomWrapperPositionInPage() - getWindowBottomPositionInPage();

          return difference <= OFFSET_FOR_FETCH_NEWS;
        };


        /**
         * инициализируем слайдеры в подгруженных новостях
         */
        var addSliderWidgetInNews = function (news) {
            $(news).find('.js-longread-slider').each(function(index, element) {
                $(element).not('.slick-initialized').slick({
                    lazyLoad: 'ondemand',
                    adaptiveHeight: true,
                    appendArrows: $(element).closest('.longread-slider-top-wrapper'),
                    prevArrow: '<a class=\"longread-slider-arrow longread-slider-arrow-back\"></a>',
                    nextArrow: '<a class=\"longread-slider-arrow longread-slider-arrow-forward\"></a>',
                })
                    .on('beforeChange', function(e, slick, currentSlideIndex, nextSlideIndex) {
                        $(this).parents('.js-longread-slider-cont').find('.js-current-slide').text(nextSlideIndex + 1);
                    });
            });
        };

        /**
         * инициализируем аккордеон внутри подгруженных новостях
         */
        var initNewsItemPlugin = function ($item) {
            if (typeof $item.data('collapse') === 'undefined') {
                $item.data('collapse', $item.collapse());
            }

            if (typeof $item.data('copyingLink') === 'undefined') {
                $item.data('copyingLink', $(this).copyingLink());
            }
        };

        /**
         * поиск новостей
         */
        var fetchFindNews = function () {
            if (isLoading || isListEnd) {
                return;
            }
            $wrapper.addClass(LOADING_CLASS);
            isLoading = true;
            $.ajax({
                url: URL,
                type: 'get',
                data: {
                    q: findData.q,
                    page: currentPage,
                    'TournamentMatchesFilter[tournamentId]': $select.val() || null,
                }
            }).done(function (response) {
                $emptyList.removeClass('show');
                isLoading = false;
                $wrapper.removeClass(LOADING_CLASS);
                $list.empty();
                $list.append(response);
                if (response.length <= 0) {
                    $emptyList.addClass('show');
                    $emptyListText.text(findData.q);
                    return;
                }

                var $items = $wrapper.find('.js-news-item');

                $items.each(function() {
                    initNewsItemPlugin($(this));
                    addSliderWidgetInNews($(this));
                });
            });
        };

        /**
         * запуск поиска по нажатию на лупу
         */
        findButton.on('click', function () {
            fetchFindNews();
        });

        /**
         * прослущивать нажатия ентер внутри инпута
         */
        findInput.keyup(function (evt) {
            if (evt.keyCode === 13) {
                fetchFindNews();
            }
        });

        /**
         * дозагрузка новостей при скроле к концу страницы
         */
        var fetchNews = function () {
            if (isLoading || isListEnd) {
                return;
            }

            $wrapper.addClass(LOADING_CLASS);
            isLoading = true;
            currentPage += 1;

            console.log('value', {
                value: $select.val(),
            })

            $.ajax({
                url: URL,
                type: 'get',
                data: {
                    q: findData.q,
                    page: currentPage,
                    'TournamentMatchesFilter[tournamentId]': $select.val() || null,
                }
            }).done(function (response) {
                isLoading = false;
                $wrapper.removeClass(LOADING_CLASS);

                if (!response) {
                    isListEnd = true;
                    return;
                }

                $list.append(response);

                var $items = $wrapper.find('.js-news-item');

                $items.each(function() {
                    initNewsItemPlugin($(this));
                    addSliderWidgetInNews($(this));
                });
            });
        };

        var scrollWindowHandler = function () {
            if (!isNeedLoadNews() || isListEnd) {
                return;
            }

            fetchNews();
        };

        var initEvents = function () {
            $(document).on('scroll', scrollWindowHandler);
        };

        initEvents();

        return this;
    };

    $('.js-cup-news-wrapper').each(function () {
        fetchNewsAfterScrollPlugin($(this));
    });
});
